import * as Yup from 'yup';

export const blogForm = Yup.object({
  contentType: Yup.string().required('Content Type is required').default('blog'),
  vehicle: Yup.object({
    year: Yup.lazy((value) => {
      return (value === '' ? Yup.string() : Yup.number()).when(
        ['make', 'model'],
        ([make, model], schema) => {
          return make || model ? schema.required('Vehicle Year is required') : schema.optional();
        }
      );
    }),
    make: Yup.lazy(() => {
      return Yup.string().when(['year', 'model'], ([year, model], schema) => {
        return year || model ? schema.required('Vehicle Make is required') : schema.optional();
      });
    }),
    model: Yup.lazy(() => {
      return Yup.string().when(['make'], ([make], schema) => {
        return make ? schema.required('Vehicle Model is required') : schema.optional();
      });
    })
  }).optional(),
  contentTopic: Yup.string()
    .required('Content Topic is required')
    .max(1500, 'Content Topic must be less than 1500 characters')
    .min(5, 'Content Topic must be more than 5 characters')
    .trim(),
  wordCount: Yup.number()
    .required('Word count is required')
    .max(2500, 'Word count must be less than 2500')
    .min(100, 'Word count must be more than 100'),
  targetAudience: Yup.string()
    .optional()
    .max(1500, 'Target Audience or Market must be less than 1500 characters'),
  geos: Yup.string().optional().max(1500, 'Geos must be less than 1500 characters'),
  contentOne: Yup.object({
    url: Yup.string()
      .optional()
      .url('Content 1 url must be an valid url')
      .max(1500, 'Content 1 url must be less than 1500 characters'),
    writeStyle: Yup.string()
      .optional()
      .max(1500, 'Content 1 Writing Style example must be less than 1500 characters')
  }).optional(),
  contentTwo: Yup.object({
    url: Yup.string()
      .optional()
      .url('Content 2 url must be an valid url')
      .max(1500, 'Content 2 url must be less than 1500 characters'),
    writeStyle: Yup.string()
      .optional()
      .max(1500, 'Content 2 Writing Style example must be less than 1500 characters')
  }).optional(),
  additionalInformation: Yup.string()
    .optional()
    .max(1500, 'Additional Information must be less than 1500 characters'),
  negativePrompt: Yup.string()
    .optional()
    .max(1500, 'Negative Prompt must be less than 1500 characters'),
  linkOne: Yup.object({
    url: Yup.string().optional().max(1500, 'Link 1 url must be less than 1500 characters'),
    description: Yup.string()
      .optional()
      .max(1500, 'Link 1 description must be less than 1500 characters')
  }).optional(),
  linkTwo: Yup.object({
    url: Yup.string().optional().max(1500, 'Link 2 url must be less than 1500 characters'),
    description: Yup.string()
      .optional()
      .max(1500, 'Link 2 description must be less than 1500 characters')
  }).optional(),
  executeCopyscapeSearch: Yup.boolean().optional(),
  dealershipAccount: Yup.object({
    id: Yup.string().when(['name', 'address'], ([name, address], schema) => {
      return !name && !Object.keys(address ?? {}).length
        ? schema.max(0, 'Dealership account could not be found')
        : schema.required().max(50, 'Dealership ID must be less than 50 characters');
    }),
    name: Yup.string()
      .optional()
      .nullable(true)
      .max(100, 'Dealership name must be less than 100 characters'),
    address: Yup.object({
      address1: Yup.string()
        .optional()
        .nullable(true)
        .max(100, 'Address 1 must be less than 100 characters'),
      address2: Yup.string()
        .optional()
        .nullable(true)
        .max(100, 'Address 2 must be less than 100 characters'),
      address3: Yup.string()
        .optional()
        .nullable(true)
        .max(100, 'Address 3 must be less than 100 characters'),
      city: Yup.string().optional().nullable(true).max(50, 'City must be less than 50 characters'),
      state: Yup.string().optional().nullable(true).max(2, 'State must be less than 2 characters'),
      postalCode: Yup.string()
        .optional()
        .nullable(true)
        .max(10, 'Postal code must be less than 10 characters')
    })
      .optional()
      .default(undefined)
  }).optional()
});

export const initialValues = {
  vehicle: {
    year: '',
    make: '',
    model: ''
  },
  contentTopic: '',
  wordCount: '',
  targetAudience: '',
  geos: '',
  contentOne: {
    url: '',
    writeStyle: ''
  },
  contentTwo: {
    url: '',
    writeStyle: ''
  },
  additionalInformation: '',
  negativePrompt: '',
  linkOne: {
    url: '',
    description: ''
  },
  linkTwo: {
    url: '',
    description: ''
  },
  executeCopyscapeSearch: true,
  dealershipAccount: {
    id: ''
  }
};

export const ASYNC_FIELDS = ['dealershipAccount'];
